"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "grezzana": {
    "1e904576": [{
      "hkey": "8e93f728",
      "slug": "stallavena-lugo",
      "name": "Stallavena-Lugo",
      "primary": true,
      "skipSearch": false
    }],
    "lugo": [{
      "hkey": "8e93f728",
      "slug": "stallavena-lugo",
      "name": "Stallavena-Lugo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "grezzana"
    }],
    "352fffe3": [{
      "hkey": "8e93f728",
      "slug": "stallavena-lugo",
      "name": "Stallavena-Lugo",
      "primary": true,
      "skipSearch": false
    }],
    "stallavena": [{
      "hkey": "8e93f728",
      "slug": "stallavena-lugo",
      "name": "Stallavena-Lugo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;